import React from 'react';
import styles from './style.js';
import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import { Card, CardContent, CardMedia, Typography } from '@material-ui/core';
import * as apiDashBoardService from '../../services/apidashboardservice.js';
import { docsInfoDynamicContentScreen } from '../../redux/constants/docsInfoContentTypes.js';
import { history } from '../../App.js';
import Slider from 'react-slick';
import moment from 'moment';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './style.css';

function SampleNextArrow(props) {
  const { className, onClick } = props;

  return (
    <div
      className={`${className} ${props.className}`}
      style={{
        ...props.style,
        backgroundImage: 'none',
        width: '56px',
        height: '36px'
      }}
      onClick={onClick}
    >
      <img src='/static/images/arrow-right.svg' alt='Next' />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;

  return (
    <div
      className={`${className} ${props.className}`}
      style={{
        ...props.style,
        backgroundImage: 'none',
        width: '56px',
        height: '36px'
      }}
      onClick={onClick}
    >
      <img src='/static/images/arrow-left.svg' alt='Previous' />
    </div >
  );
}

class FeaturedAPIs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      announcements: []
    };
  }

  componentDidMount() {
    apiDashBoardService.getAnnouncements()
      .then((result) => {
        this.setState({
          isLoaded: true,
          announcements: result.data
        });
      }, (error) => {
        this.setState({
          isLoaded: true,
          error
        });
      });
  };
  handleClick = (e, id) => {
    this.props.actions.switchDocsMainContentToInfo();
    this.props.actions.setDocsApiInfo(id, docsInfoDynamicContentScreen, false);
    history.push({
      pathname: '/docs',
      state: { isLinked: true }
    });
  };

  render() {
    const { classes } = this.props;
    const { error, isLoaded, announcements } = this.state;

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      className: 'ImprovementsSlider',
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false
          }
        }
      ]
    };

    if (error) {
      return <div className='text-danger text-center'>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div className='text-warning text-center'>Loading...</div>;
    }
    return (
      <Slider {...settings}>
        {announcements.length > 2 && announcements.filter((item, i) => item.status === true).reverse().map((item, i) => (
          <Link href={'/announcement'} key={item.id} className={`position-relative w-100 px-3 ${classes.topMarginForSlides}`}>
            <Card className={'shadow-none'}>
              <CardMedia
                component="img"
                style={{ height: 'auto', width: '100%' }}
                image={`/static/images/announcements/${item.imageUrl}.png`}
                alt={item.title}
              />
              <div className={`position-absolute text-white text-center ${classes.dateCard} ${i % 2 !== 0 ? classes.dateCardSecond : ''}`}>
                <span className='h2'>{moment(item.createDate).format('DD')}</span><br />
                <span className='h4'>{moment(item.createDate).format('MMM')}</span>
              </div>
              <CardContent>
                <Typography gutterBottom variant="h3" component="h3" className={classes.sliderTitle} style={{textAlign: 'center'}}>
                  {item.title}
                </Typography>
              </CardContent>
            </Card>
          </Link>
        ))}
      </Slider>
    );

  }
}

export default withStyles(styles)(FeaturedAPIs);
